(()=>{
  'use strict';
  const body=document.body;
  const root=document.documentElement;
  const ai=document.querySelector('[data-mbf-ai-modal]');
  const menu=document.querySelector('[data-mbf-mobile-menu]');
  const floaters=[...document.querySelectorAll('.ai-launcher,.whatsapp-float')];

  const syncOverlayState=()=>{
    const aiOpen=Boolean(ai&&!ai.hidden);
    const menuOpen=Boolean(menu&&!menu.hidden);
    body.classList.toggle('mbf-ai-open',aiOpen);
    body.classList.toggle('mbf-menu-open',menuOpen);
    if(aiOpen||menuOpen){floaters.forEach(el=>el.setAttribute('aria-hidden','true'));}
    else{floaters.forEach(el=>el.removeAttribute('aria-hidden'));}
  };

  [ai,menu].forEach(el=>{
    if(!el)return;
    new MutationObserver(syncOverlayState).observe(el,{attributes:true,attributeFilter:['hidden','aria-hidden']});
  });

  let baseLayoutHeight=Math.max(window.innerHeight,document.documentElement.clientHeight);
  const syncViewport=()=>{
    const vv=window.visualViewport;
    const h=vv?vv.height:window.innerHeight;
    const top=vv?vv.offsetTop:0;
    root.style.setProperty('--mbf-vv-height',`${Math.max(320,h)}px`);
    root.style.setProperty('--mbf-vv-top',`${Math.max(0,top)}px`);
    const keyboardOpen=(baseLayoutHeight-h)>120;
    body.classList.toggle('mbf-keyboard-open',keyboardOpen);
    if(!keyboardOpen&&window.innerHeight>baseLayoutHeight) baseLayoutHeight=window.innerHeight;
  };

  syncOverlayState();
  syncViewport();
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',syncViewport,{passive:true});
    window.visualViewport.addEventListener('scroll',syncViewport,{passive:true});
  }
  window.addEventListener('resize',()=>{
    if(!body.classList.contains('mbf-keyboard-open')) baseLayoutHeight=Math.max(window.innerHeight,document.documentElement.clientHeight);
    syncViewport();
  },{passive:true});
  document.addEventListener('focusin',e=>{
    if(e.target&&/^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) requestAnimationFrame(syncViewport);
  });
  document.addEventListener('focusout',()=>setTimeout(syncViewport,80));
})();
